import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/features/events/services/dashboard.service';

@Component({
  selector: 'app-primary.outlet',
  templateUrl: './primary.outlet.component.html',
  styleUrls: ['./primary.outlet.component.css'],
  providers: [DashboardService],
})
export class PrimaryOutletComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
